import { render, staticRenderFns } from "./VirtualParameter.vue?vue&type=template&id=4c67e5f4&scoped=true&"
import script from "./VirtualParameter.script.js?vue&type=script&lang=js&"
export * from "./VirtualParameter.script.js?vue&type=script&lang=js&"
import style0 from "./VirtualParameter.scss?vue&type=style&index=0&id=4c67e5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c67e5f4",
  null
  
)

export default component.exports